// Centralised content (Hungarian) for Pakkaland landing page
export const SITE = {
  brand: "PAKKALAND",
  tagline: "A Tisza partján, a tűz melegénél",
  address: "Vezseny, Komp utca 8.",
  phone: "+36 30 900 5883",
  phoneHref: "tel:+36309005883",
  email: "pakkaland25@gmail.com",
  emailHref: "mailto:pakkaland25@gmail.com",
  social: {
    facebook: "https://facebook.com/pakkaland",
    instagram: "https://instagram.com/pakkaland",
  },
  mapEmbed:
    "https://www.google.com/maps?q=Vezseny,Komp+utca+8&output=embed",
};

export const NAV = [
  { label: "Falusi vendégasztal", href: "/falusi-vendegasztal" },
  { label: "Vendégház", href: "/vendeghaz" },
  { label: "Gyerek workshopok", href: "/gyerek-workshopok" },
  { label: "Egyedi vágódeszkák", href: "/vagodeszkak" },
  { label: "Rólunk", href: "/rolunk" },
];

export const EXPERIENCES = [
  {
    title: "Falusi vendégasztal",
    desc: "Közös étkezések a hosszú asztalnál, tűz körüli történetek és lassan érlelt ízek.",
    icon: "Users",
  },
  {
    title: "Kemencés estek",
    desc: "Kenyerek, pizzák, piták és tematikus vacsorák a kemence ölelő melegében.",
    icon: "Flame",
  },
  {
    title: "Vendégház",
    desc: "Dézsa, jakuzzi, fűthető kerti kiülő – természetközeli pihenés a Tisza partján.",
    icon: "Home",
  },
  {
    title: "Workshopok",
    desc: "Gyerekprogramok, kenyérsütés, kézműves élmények – nem csak megnézed, megtanulod.",
    icon: "Sparkles",
  },
];

export const EVENTS = [
  {
    name: "Őszváró a Pakkalandban",
    date: "2026. szeptember 12., szombat",
    short: "SZE 12",
    desc: "A nyár lassan búcsúzik, mi pedig együtt köszöntjük az őszt balkáni ízekkel, tűzzel, állatokkal, játékokkal és jó társasággal a Pakkalandban!",
    img: "/images/oszvaro.jpg",
    reservationHref: "https://esemeny.pakkaland.hu",
    note: "A férőhelyek száma korlátozott, előzetes foglalás szükséges!",
    program: [
      {
        time: "15:00",
        title: "Érkezés",
        desc: "Üdvözlőitallal és kötetlen kikapcsolódással várjuk vendégeinket. Közben természetesen a Pakkaland állataival is megismerkedhettek.",
      },
      {
        time: "16:00",
        title: "Füstölt marhahúsos-zöldséges leves",
        desc: "Tartalmas, házias leves füstölt marhahússal és zöldségekkel, lassan, sok-sok ízzel elkészítve.",
      },
      {
        time: "17:00",
        title: "Pakkaland játékok gyerekeknek és felnőtteknek",
        desc: "Eljött a nevetés, a játék és a barátságos versengés ideje! Külön verseny a gyerekeknek és a felnőtteknek: tojásfutás kanállal, zsákban futás, kötélhúzás. A legügyesebb versenyzőket Pakkaland-ajándékokkal jutalmazzuk!",
      },
      {
        time: "18:00",
        title: "Balkáni grillezés",
        desc: "Ćevapi, pljeskavica és grillezett marhahús — mellé köretek, friss saláták, ajvár, hagyma és minden, ami egy igazi balkáni grillezéshez hozzátartozik.",
      },
      {
        time: "20:00",
        title: "Eredményhirdetés",
        desc: "",
      },
      {
        time: "20:15",
        title: "Sütemények és hagyományos bosnyák kávé",
        desc: "",
      },
      {
        time: "21:00-tól",
        title: "Közös időtöltés a tűz mellett",
        desc: "Zene, italok, tűz és kötetlen beszélgetés a szabad ég alatt. Együtt búcsúztatjuk a nyarat és köszöntjük az őszt.",
      },
    ],
  },
];

export const GALLERY = [
  "/images/7vofl2kc.jpg",
  "/images/nkl5175x.jpg",
  "/images/ffzlam8f.jpg",
  "/images/zohq6t2d.jpg",
  "/images/d5l3w5vu.jpg",
  "/images/0zojj48e.jpg",
  "/images/rjkboggp.jpg",
  "/images/eskjx3c6.jpg",
];

export const BOARDS = [
  {
    id: "vagodeszka",
    title: "Egyeztetés alatt",
    sub: "Vágódeszka",
    desc: "Hamarosan elérhető — egyedi méret, fafajta és epoxi erezet egyeztetés szerint.",
    price: 35000,
    img: "/images/jujl9t14.jpg",
  },
  {
    id: "talalodeszka",
    title: "Egyeztetés alatt",
    sub: "Tálalódeszka",
    desc: "Hamarosan elérhető — egyedi méret, fafajta és epoxi erezet egyeztetés szerint.",
    price: 45000,
    img: "/images/jujl9t14.jpg",
  },
  {
    id: "limitalt",
    title: "Egyeztetés alatt",
    sub: "Limitált kiadás",
    desc: "Hamarosan elérhető — egyedi méret, fafajta és epoxi erezet egyeztetés szerint.",
    price: 65000,
    img: "/images/jujl9t14.jpg",
  },
];

export const formatHUF = (n) =>
  new Intl.NumberFormat("hu-HU").format(n) + " Ft";
